import React, { useEffect, useRef, useState } from 'react';
import { ShoppingBagIcon, XIcon } from 'lucide-react';
import { PRODUCT_NAME } from './constants';
const samplePurchases = [{
  name: 'Michael R.',
  location: 'Manchester, United Kingdom'
}, {
  name: 'Gary H.',
  location: 'Leeds, United Kingdom'
}, {
  name: 'Ian P.',
  location: 'Glasgow, United Kingdom'
}, {
  name: 'Doug F.',
  location: 'Hamilton, Canada'
}, {
  name: 'Shane M.',
  location: 'Calgary, Canada'
}, {
  name: 'Tyler B.',
  location: 'Edmonton, Canada'
}, {
  name: 'Ray S.',
  location: 'Columbus, United States'
}, {
  name: 'Dale W.',
  location: 'Houston, United States'
}, {
  name: 'Anthony G.',
  location: 'Phoenix, United States'
}, {
  name: 'Trevor B.',
  location: 'Brisbane, Australia'
}, {
  name: 'Scott D.',
  location: 'Perth, Australia'
}, {
  name: 'Liam F.',
  location: 'Newcastle, Australia'
}];
export function PurchasePopup() {
  const [visible, setVisible] = useState(false);
  const [current, setCurrent] = useState(samplePurchases[0]);
  const hideTimer = useRef<ReturnType<typeof setTimeout> | null>(null);
  useEffect(() => {
    const showPopup = () => {
      setCurrent(samplePurchases[Math.floor(Math.random() * samplePurchases.length)]);
      setVisible(true);
      if (hideTimer.current) clearTimeout(hideTimer.current);
      hideTimer.current = setTimeout(() => setVisible(false), 5000);
    };
    const initialTimer = setTimeout(showPopup, 3000);
    const interval = setInterval(showPopup, 15000);
    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
      if (hideTimer.current) clearTimeout(hideTimer.current);
    };
  }, []);
  if (!visible) return null;
  return <aside className="fixed bottom-3 left-3 z-50 w-[calc(100%-1.5rem)] max-w-[258px] animate-slide-in" aria-live="polite" data-id="element-149" data-mp="s5okyydk5oy0">
      <div className="relative overflow-hidden rounded-xl border-2 border-brand-yellow bg-white p-2.5 pr-7 shadow-2xl ring-2 ring-brand-carbon" data-id="element-150" data-mp="28jeoo40rmb74">
        <div className="absolute inset-x-0 top-0 h-1 bg-brand-yellow" data-id="element-151" data-mp="23npmru19wi7n" />
        <button type="button" onClick={() => setVisible(false)} className="absolute right-1.5 top-1.5 rounded p-0.5 text-brand-muted transition-colors duration-150 ease-out hover:text-brand-carbon" aria-label="Close purchase notification" data-id="element-152" data-mp="2ao1qz900i9v1">
          <XIcon className="h-3.5 w-3.5" data-id="element-153" data-mp="2plka9vtx7uv3" />
        </button>
        <div className="flex items-center gap-2.5" data-id="element-154" data-mp="2pl2hj96gvyrx">
          <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full border-2 border-brand-carbon bg-brand-yellow" data-id="element-155" data-mp="1rylkm51nbn6p">
            <ShoppingBagIcon className="h-4 w-4 text-brand-carbon" data-id="element-156" data-mp="1wxoequg388zw" />
          </div>
          <div className="min-w-0 leading-tight" data-id="element-157" data-mp="21v82ckyody4i">
            <p className="font-cond text-sm font-bold uppercase text-brand-carbon" data-id="element-158" data-mp="26mzlwbjez3l5">
              {current.name}
            </p>
            <p className="text-[11px] font-semibold text-brand-muted" data-id="element-159" data-mp="198dnc3kmnqyf">from {current.location}</p>
            <p className="mt-0.5 text-[11px] font-bold uppercase text-brand-carbon" data-id="element-160" data-mp="1e65h734u1n59">
              just purchased {PRODUCT_NAME}
            </p>
          </div>
        </div>
      </div>
    </aside>;
}